module.exports = "/_next/static/images/cusa_logo_mobile_2025-a74e5442d29bca9d38fd5ecd448c2151.svg";